'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { FullHeightPreviewFrame } from 'content-embed-lib/preview/components/FullHeightPreviewFrame';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PreviewIframe extends Component {
  constructor(props) {
    super(props);
    this.renderEmailDetails = this.renderEmailDetails.bind(this);
  }
  renderEmailDetails() {
    const {
      to,
      from,
      subject
    } = this.props;
    const toMessage = to && to.name && to.name.length > 0 ? 'ContentComponents.previewDevices.details.to' : 'ContentComponents.previewDevices.details.notSelectedTo';
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-raised",
      borderBlockEndColor: "border-primary-default",
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      paddingBlock: "200",
      paddingInline: "100",
      "data-test-id": "previewEmailDetails",
      children: /*#__PURE__*/_jsxs(ExpandableText, {
        maxHeight: 150,
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: toMessage,
            options: to
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "ContentComponents.previewDevices.details.from",
            options: from
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "ContentComponents.previewDevices.details.subject",
            options: {
              prop: subject
            }
          })
        })]
      })
    });
  }
  render() {
    const {
      previewUrl,
      previewHTMLOutput,
      shouldUseHTMLPreview = false,
      onLoad,
      uniqueFrameId,
      contentType,
      customPreview,
      type,
      inpage
    } = this.props;
    const iframeProps = Object.assign({
      id: 'content-preview-iframe'
    }, shouldUseHTMLPreview ? {} : {
      src: previewUrl
    }, {
      onLoad,
      sandbox: 'allow-scripts allow-same-origin allow-forms allow-popups allow-modals allow-popups-to-escape-sandbox',
      style: {
        flexGrow: 1,
        border: 'none',
        width: '100%'
      }
    });
    return /*#__PURE__*/_jsxs(Flex, {
      display: "flex",
      flexDirection: "column",
      blockSize: "100%",
      children: [contentType === 'email' && this.renderEmailDetails(), customPreview || shouldUseHTMLPreview && /*#__PURE__*/_jsx(FullHeightPreviewFrame, {
        isFullscreen: true,
        html: previewHTMLOutput,
        shouldReplaceAllHTML: true,
        includeHeadElements: true,
        uniqueFrameId: `${uniqueFrameId}-${type}`,
        iframePropsOverrides: iframeProps,
        inpage: inpage
      }) || /*#__PURE__*/_jsx("iframe", Object.assign({}, iframeProps))]
    });
  }
}
PreviewIframe.defaultProps = {
  from: {
    email: '',
    name: ''
  },
  to: {
    email: '',
    name: ''
  }
};
PreviewIframe.propTypes = {
  previewUrl: PropTypes.string.isRequired,
  previewHTMLOutput: PropTypes.string,
  onLoad: PropTypes.func.isRequired,
  from: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string
  }),
  to: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string
  }),
  type: PropTypes.bool,
  subject: PropTypes.string,
  uniqueFrameId: PropTypes.string,
  shouldUseHTMLPreview: PropTypes.bool,
  contentType: PropTypes.string,
  customPreview: PropTypes.object,
  inpage: PropTypes.bool
};
export default PreviewIframe;